export default "__VITE_ASSET__4a23f593__"